import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { HeaderService } from '../../../services/header-service';
import {AboutArray, Services, ServicesArray} from '../../../model/services';
import { ServicesService } from '../../../services/services-service';
import { Subscription } from 'rxjs';
import {Card} from '../../../model/cards';
import {LocationDto} from '../../../model/continent';
import {SyncService} from '../../../services/sync-service';
import {getFirstSentence} from '../../../functions/getFirstSentence';
import {NgForOf} from '@angular/common';
import {CountryInfoElComponent} from '../../elements/country-info-el/country-info-el.component';
import {SliderHorizontalComponent} from './elements/slider-horizontal/slider-horizontal.component';
import {extractFirstParagraph} from '../../../functions/extractFirstParagraph';
import {LoadingService} from '../../../services/loading-service';
import {TextsComponent} from '../../elements/texts/texts.component';

@Component({
  selector: 'app-services-page',
  imports: [
    NgForOf,
    CountryInfoElComponent,
    SliderHorizontalComponent,
    TextsComponent,
  ],
  templateUrl: './services-page.component.html',
  styleUrl: './services-page.component.scss'
})
export class ServicesPageComponent implements OnInit, OnDestroy {
  constructor(
    protected interfaceService: HeaderService,
    private service: ServicesService,
    private syncService: SyncService,
    private cdr: ChangeDetectorRef,
    public loadingService: LoadingService,) {}

  position: number = 0;
  services: Services[] = ServicesArray;
  servicesCards: Card[] = [];
  servicesDto: LocationDto[] = [];
  private subscription!: Subscription;
  private syncSubscription!: Subscription;
  private forceSyncSubscription!: Subscription;

  loading: boolean = true;
  isMobile: boolean = false;
  private isHeaderTransparent: boolean = true;

  ngOnInit() {
    this.isMobile = window.innerWidth <= 769;
    this.loading = true;
    this.loadingService.setLoadingValue(true);
    this.interfaceService.setPageInterface('header-transparent');
    this.setCards();
    this.position = this.service.getActiveService();
    this.subscription = this.service.getActiveServiceObservable()
      .subscribe((newPosition: number) => {
        if (newPosition !== this.position) {
          this.position = newPosition;
        }
      });
    this.syncSubscription = this.syncService.getSlideIndex()
      .subscribe((index: number) => {
        this.onCardClicked(index);
      });
    this.forceSyncSubscription = this.syncService.getForceSlideIndex()
      .subscribe((index: number) => {
        this.onCardClickedForce(index);
      });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const windowHeight = window.innerHeight - 80;
    if (scrollPosition >= windowHeight && this.isHeaderTransparent) {
      this.interfaceService.setPageInterface('header-container-white');
      this.isHeaderTransparent = false;
    } else if (scrollPosition < windowHeight && !this.isHeaderTransparent) {
      this.interfaceService.setPageInterface('header-transparent');
      this.isHeaderTransparent = true;
    }
  }

  onCardClicked(index: number): void {
    this.position = index;
  }

  onCardClickedForce(index: number): void {
    const tempPosition = this.position;
    this.position = (index === 0) ? -1 : index - 1;
    setTimeout(() => {
      this.position = index;
      this.cdr.detectChanges();
      this.servicesDto = [...this.servicesDto];
    });
  }

  setCards() {
    this.servicesCards = ServicesArray.map((v, index) => {
      let titleRu: string = '';
      let titleEn: string = '';
      let style: string = '';
      let descrRu = '';
      let descrEn = ''
      if (v.subtitle !== undefined) {
        descrRu = getFirstSentence(v.subtitle[0]);
        descrEn = getFirstSentence(v.subtitle[1]);
      }
      if (v.title?.[0]?.text?.[0] != undefined) {
        titleRu = v.title[0].text[0];
      }
      if (v.title?.[0]?.text?.[1] != undefined) {
        titleEn = v.title[0].text[1];
      }
      if (v.filter !== undefined && v.filter && v.filterNumber === undefined) {
        style = `100`
      }
      if (v.filter !== undefined &&
        v.filter &&
        v.filterNumber !== undefined &&
        v.filterNumber > 0) {
        style = v.filterNumber.toString();
      }
      return new Card(
        {
          title: [],
          text: [titleRu, titleEn],
          img: v.img,
          style: style,
          link: 'mock',
          anotherButton: true,
          anotherHotelButton: true,
          anotherButtonText: [{text: [descrRu, descrEn]}],
        },
      )
    });
    this.servicesDto = ServicesArray.map((v, index) => {
      let titleRu: string = '';
      let titleEn: string = '';
      let style: string = '';
      if (v.title?.[0]?.text?.[0] != undefined) {
        if (this.isMobile && v.mobileTitle?.[0]?.text?.[0] != undefined) {
          titleRu = v.mobileTitle[0].text[0];
        } else {
          titleRu = v.title[0].text[0];
        }
      }
      if (v.title?.[0]?.text?.[1] != undefined) {
        if (this.isMobile && v.mobileTitle?.[0]?.text?.[1] != undefined) {
          titleEn = v.mobileTitle[0].text[1];
        } else {
          titleEn = v.title[0].text[1];
        }
      }
      if (v.filter !== undefined && v.filter && v.filterNumber === undefined) {
        style = `filter: grayscale(100%);`
      }
      if (v.filter !== undefined &&
        v.filter &&
        v.filterNumber !== undefined &&
        v.filterNumber > 0) {
        style = `filter: grayscale(${v.filterNumber}%);`
      }
      let descriptionRu: string | undefined = '';
      if (v.subtitle !== undefined) {
        descriptionRu = v.subtitle[0];
      }
      let descriptionEn: string | undefined = '';
      if (v.subtitle !== undefined) {
        descriptionEn = v.subtitle[1];
      }
      return new LocationDto({
        url: 'feedback',
        link: '',
        points: [],
        carousels: [],
        events: [],
        additionalEvents: [],
        titleEn: titleEn,
        titleRu: titleRu,
        descriptionEn: descriptionEn,
        descriptionRu: descriptionRu,
        image: v.img,
        orderNumber: 0,
        titleNatural: '',
        cssStyleImage: style,
        adventures: [],
        version: 0,
        services: true,
        button: true,
        titleBackgroundButtonText: [{text: ['Make request', 'Make request']}],
        feedValue: v.feedValue ?? [],
        firstParagraph: extractFirstParagraph([descriptionRu, descriptionEn]),
        objectPosition: v.objectPosition,
        scale: v.scale,
        getCountryLink: function() {
          return ''
        }
      });
    });
    this.loading = false;
    this.loadingService.setLoadingValue(false);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.syncSubscription) {
      this.syncSubscription.unsubscribe();
    }
    if (this.forceSyncSubscription) {
      this.forceSyncSubscription.unsubscribe();
    }
  }

  protected readonly AboutArray = AboutArray;
  protected readonly window = window;
}
